import { render, staticRenderFns } from "./I-0-4-1-3-1__IR-Financial Information_Create.vue?vue&type=template&id=07063976&"
import script from "./I-0-4-1-3-1__IR-Financial Information_Create.vue?vue&type=script&lang=js&"
export * from "./I-0-4-1-3-1__IR-Financial Information_Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
